import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { ComboAluno } from 'src/app/core/combo-aluno';
import { ComboPessoaFisica } from 'src/app/core/combo-pessoa-fisica';
import { ExportacaoDadosAluno } from 'src/app/core/exportacao-dados-aluno';
import { Unidade } from 'src/app/core/unidade';
import { CpfPipe } from 'src/app/pipes/cpf.pipe';
import { AlunoService } from 'src/app/services/aluno/aluno.service';
import { DataUtilService } from 'src/app/services/commons/data-util.service';
import { FuncoesUteisService } from 'src/app/services/commons/funcoes-uteis.service';
import { ExportacaoDadosAlunoService } from 'src/app/services/exportacao-dados-aluno/exportacao-dados-aluno.service';
import { LoadingPopupService } from 'src/app/services/loadingPopup/loading-popup.service';
import { PessoaFisicaService } from 'src/app/services/pessoa-fisica/pessoa-fisica.service';
import { RelatorioBeneficiarioService } from 'src/app/services/relatorio-beneficiario/relatorio-beneficiario.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { UnidadeService } from 'src/app/services/unidade/unidade.service';
import { FileUtils } from 'src/app/utils/file-utils';
import { Modulos } from '../../../core/modulos';
import { SelecionadoHistoricoBeneficiario } from '../../../core/selecionado-historico-beneficiario';
import { ControleMenuService } from '../../../services/controle-menu/controle-menu.service';

export interface TipoRelatorioBeneficiario {
  tipo: string;
  descricao: string;
}

export class FilterExportacao{
  beneficiario: ComboAluno;
  cpfAluno: ComboPessoaFisica;
  dataInicioInstituicao: Date;
  dataFimInstituicao: Date;
  tipoPedagogicoSelecionado: Boolean;
  tipoPsicossocialSelecionado: Boolean;
  
  unidade: Unidade;
}

@Component({
  selector: 'relatorios-historico-beneficiario',
  templateUrl: './relatorios-historico-beneficiario.component.html',
  styleUrls: ['./relatorios-historico-beneficiario.component.css'],
  providers: [CpfPipe],
})
export class RelatoriosHistoricoBeneficiarioComponent implements OnInit {

  tipoPedagogicoSelecionado: Boolean = true;
  tipoPsicossocialSelecionado: Boolean = false;

  MIMETYPE_PDF   = "pdf";
  MIMETYPE_EXCEL = "xls";

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  comboCpf: ComboPessoaFisica[];
  comboResponsaveis: ComboPessoaFisica[];
  comboUnidades: Unidade[];

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil;

  displayedColumns: string[] = ['select', 'matricula','beneficiario','dataEntrada', 'dataDesligamento'];
  dataSource: MatTableDataSource<ExportacaoDadosAluno> = new MatTableDataSource();
  mostrarTabela: boolean = false;
  msg: string;

  selection = new SelectionModel<ExportacaoDadosAluno>(true, []);

  filtro: FilterExportacao = new FilterExportacao();
  exportacaoDadosAlunos: ExportacaoDadosAluno[]

  panelBeneficiarioOpenState = false;
  panelFamiliarOpenState     = false;

  constructor(
    private exportacaoDadosAlunoService: ExportacaoDadosAlunoService,
    private toastService: ToastService,
    private dataUtilService: DataUtilService,
    private fileUtils: FileUtils,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private loadingPopupService: LoadingPopupService,
    private relatorioBeneficiarioService: RelatorioBeneficiarioService,
    private cpfPipe: CpfPipe,
    private funcoesUteisService: FuncoesUteisService,
    private pessoaFisicaService: PessoaFisicaService,
    private unidadeService: UnidadeService,
    private beneficiarioService: AlunoService,
    private controleMenuService: ControleMenuService
  ) { 
    this.carregarPerfil = new CarregarPerfil();
  }

  ngOnInit(): void {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);
    this.limpar();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.carregarCombos();
  }

  consultar() {
    if (!this.validarDatas()) return;
    this.selection.clear();
    this.exportacaoDadosAlunos = [];
    this.dataSource.data = [];
    this.loadingPopupService.mostrarMensagemDialog('Buscando, aguarde...');
    this.exportacaoDadosAlunoService.getRelatorioHistoricoBeneficiario(
      this.filtro.cpfAluno.cpf, this.filtro.beneficiario.id, this.filtro.dataInicioInstituicao, this.filtro.dataFimInstituicao)
    .subscribe(
      (dados: ExportacaoDadosAluno[]) => {
        this.loadingPopupService.closeDialog();
        this.exportacaoDadosAlunos = dados;
        this.dataSource.data = dados ? dados : [];
        this.dataSource.data.forEach(row => this.selection.select(row));
        this.verificaMostrarTabela(dados);
        
    },
    (error) => {
      this.toastService.showAlerta("Não foi possível recuperar os dados.")
      this.loadingPopupService.closeDialog();
    });
  }

  validarDatas(): boolean {
      const dataInicio = this.dataUtilService.getDataTruncata(this.filtro.dataInicioInstituicao);
      const dataFim = this.dataUtilService.getDataTruncata(this.filtro.dataFimInstituicao);

      if (dataFim) {
          if (dataInicio && dataInicio.getTime() > dataFim.getTime()) {
              this.toastService.showAlerta("A data de início informada não pode ser maior que a data de fim.");
              return false;
          }
          let ontem: Date = new Date();
          ontem.setDate(ontem.getDate() - 1);

          if (dataFim.getTime() > ontem.getTime()) {
              this.toastService.showAlerta("A data de fim informada não pode ser hoje ou dia posterior.");
              return false;
          }

      }
      return true;
  }

  
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

  verificaMostrarTabela(lista: ExportacaoDadosAluno[]) {
    if (!lista || lista.length == 0) {
      this.mostrarTabela = false;
      this.msg = "Nenhuma registro encontrado para o relatório."
    } else {
      this.mostrarTabela = true;
    }
  }

  public handlePageBottom(event: PageEvent) {
    this.paginator.pageSize = event.pageSize;
    this.paginator.pageIndex = event.pageIndex;
    this.paginator.page.emit(event);
  }

  getRelatorio(mimetype: string) {
    if (!this.validarDatas()) return;
    if(this.selection.selected && this.selection.selected.length === 0) {
      this.toastService.showAlerta('Selecione pelo menos um registro que deseja gerar o relatório.');
      return;
    }

    
    this.loadingPopupService.mostrarMensagemDialog('Gerando relatório ..');
    
    const listaSelecionados: SelecionadoHistoricoBeneficiario[] = this.selection.selected.map(d => d);
    this.relatorioBeneficiarioService.showRelatorioHistorico(
      this.tipoPedagogicoSelecionado, this.tipoPsicossocialSelecionado, mimetype, listaSelecionados, this.filtro.dataInicioInstituicao, this.filtro.dataFimInstituicao).subscribe(
      response => {
        if(mimetype === this.MIMETYPE_PDF) {
          this.fileUtils.showFilePDF(response);
        } else {
          this.fileUtils.downloadFileXLS(response, "relatório.xlsx");
        }
      },
      responseError => {
        const dataView = new DataView(responseError.error);
        const decoder = new TextDecoder('utf8');
        const resp = JSON.parse(decoder.decode(dataView));
        this.toastService.showAlerta(resp.mensagem);

      }).add(() => {
        this.loadingPopupService.closeDialog();
      });
  }

  limpar() {
    this.filtro = new FilterExportacao();

    this.filtro.beneficiario = new ComboAluno();
    this.filtro.cpfAluno     = new ComboPessoaFisica();
    this.filtro.unidade      = new Unidade();
    this.filtro.tipoPedagogicoSelecionado = this.tipoPedagogicoSelecionado;
    this.filtro.tipoPsicossocialSelecionado = this.tipoPsicossocialSelecionado;

    this.selection.clear();
    this.exportacaoDadosAlunos = [];
    this.dataSource.data = [];
    this.mostrarTabela = false;
  }
  
  onValorChange(event: any) {
    this.filtro.beneficiario = event;
  }

  private carregarCombos(){
    this.unidadeService.getAllByInstituicaoDaUnidadeLogada().subscribe((unidades: Unidade[]) => {
      this.comboUnidades = unidades;
    });

    this.pessoaFisicaService.getAllPessoasByCombo().subscribe((pessoas: ComboPessoaFisica[]) => {
      this.comboCpf   = pessoas;
      this.comboCpf = this.ordenarComboCpfDistinct(this.comboCpf);
    });
  }

  private ordenarComboCpfDistinct(comboCpf: any): any[] {
    comboCpf.forEach(a => {
      a.cpf = a.cpf || '00000000000';
      a.cpf = this.cpfPipe.transform(a.cpf);
    });
    comboCpf = this.funcoesUteisService.ordernarArray(comboCpf, 'cpf');
    comboCpf = this.funcoesUteisService.arrayDistinct(comboCpf, 'cpf');
    return comboCpf;
  }
  
  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  verificaAcesso(modulo: Modulos) {
    return this.controleMenuService.verificaAcessoModulo(modulo);
  }

  getModulos() {
    return Modulos;
  }
}
